module.exports = __webpack_public_path__ + "b7fb08caa431771c6f4960702726aef1.mp3";